'use client'

import { TIME_RANGES } from '../../constants'
import type { TimeRangeKey } from '../../types'
import styles from './TimeRangeSelect.module.css'

interface TimeRangeSelectProps {
  value: TimeRangeKey
  onValueChange: (value: TimeRangeKey) => void
}

export default function TimeRangeSelect({ value, onValueChange }: TimeRangeSelectProps) {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <label htmlFor="time-range-select" className={styles.sr_only}>
          Select time range
        </label>
        <select
          id="time-range-select"
          className={styles.select}
          value={value}
          onChange={(e) => onValueChange(e.target.value as TimeRangeKey)}
        >
          {Object.entries(TIME_RANGES).map(([key, { label }]) => (
            <option key={key} value={key}>
              {label}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}